import { RootState } from "@/store";
import { Message, messageActions } from "@/store/reducers/messages";
import { connect, useDispatch } from "react-redux";
import styles from './messages.module.scss';
import { MdClose } from "react-icons/md";
import { useEffect } from "react";

interface Props {
    messages: Message[]
}

function mapStateToProps(state: RootState): Props {
    return {
        messages: state.messages.messages
    };
}

const MessageComponent = ({ message }: { message: Message }) => { 
    const dispatch = useDispatch();

    useEffect(() => {
        if ((message.duration ?? 0) > 0) {
            setTimeout(() => {
                dispatch(messageActions.remove(message.uuid));
            }, message.duration);
        }
    }, []);

    return (
        <div className={styles.message} key={message.uuid}>
            <div className={styles.title_close}>
                <div className={styles.title}>{ message.title }</div>
                {
                    (message.dismissable ?? true) && (
                        <div className={styles.close} onClick={(e) => dispatch(messageActions.remove(message.uuid))}>
                            <MdClose size={20}></MdClose>
                        </div>
                    )
                }
                
            </div>
           
           <div className={styles.body}>
                { message.body }
           </div>
        </div>
    )
}

const MessagesComponent = (props: Props) => {
    return (
        <div className={styles.container}>
            {
                props.messages.map(m => {
                    return (
                        <MessageComponent key={m.uuid} message={m} />
                    )
                })
            }
        </div>
    )
}

export default connect(mapStateToProps)(MessagesComponent);